import { computed, inject, Injectable, Signal, signal } from '@angular/core';
import { ReadonlyRepositoryListService, Result } from '@softline/core';
import { RohstoffbereitstellungDetailRepository } from '../repositories/detail.repository';
import { Detail } from '../data/detail';
import { QueryService, RohstoffbereitstellungQuery } from './query.service';

@Injectable()
export class RohstoffbereitstellungDetailService extends ReadonlyRepositoryListService<
  Detail,
  Result<Detail[]>,
  RohstoffbereitstellungQuery | undefined
> {
  readonly #queryService = inject(QueryService);

  override params: Signal<RohstoffbereitstellungQuery | undefined> = computed(() => {
    const query = this.#queryService.query();
    if (!query) return undefined;
    return query;
  });

  constructor() {
    super(inject(RohstoffbereitstellungDetailRepository));
  }

  protected override getItems(result: Result<Detail[]> | null | undefined): Detail[] {
    return result?.result ?? [];
  }
}
